import Button from "@material-ui/core/Button";
import React from "react";
import gameButtonStyles from "../../styles/GameButton.styles";

const YardButton = ({
	yard,
	fieldLength,
	selected,
	onClick,
	disabled = false
}) => {
	const classes = gameButtonStyles({ selected, disabled });
	const yardline = yard <= fieldLength / 2 ? yard : fieldLength - yard;

	return (
		<Button
			id={`yardline-${yardline}`}
			onClick={() => onClick(yard)}
			variant="outlined"
			className={classes.root}
			disabled={disabled}
			aria-pressed={selected}
		>
			{yardline}
		</Button>
	);
};

export default YardButton;
